import { FC } from 'react'

import { MenuItem } from 'ui/storefront'
import { MenuStandardSlideOutMobileMenu } from 'storefront-modules/layout/Menu/MenuStandard'
import useAppConfig from '#/src/custom/hooks/useAppConfig'

export interface ISlideOutMobileMenuProps {
  menuItems: MenuItem[]
}

const SlideOutMobileMenu: FC<ISlideOutMobileMenuProps> = ({ menuItems }) => {
  const appConfig = useAppConfig()

  return (
    <MenuStandardSlideOutMobileMenu
      menuItems={menuItems}
      paths={{
        categories: appConfig.paths.categoriesUrlPath
      }}
    />
  )
}

export default SlideOutMobileMenu
